import React from 'react'
import { connect } from 'react-redux'
// Image specific
import * as ImgPick from 'expo-image-picker'
import { checkCameraPermissions, confirmOrAskCameraPermissions } from '../../../modules/apis/permissions'
import { Asset } from 'expo-asset'
import { Dialogue } from '../../../modules/helpers'

// Visual
import { TouchableOpacity, Image, Text, Platform } from 'react-native'
import { Component, Avatar } from '../../stateless/common/generic'

class ShowOrPickImage extends Component {

	state = {
		imgSource: 'gallery',
		image: undefined
	}


	pickImage =  async f => {
		
		// If on mobile, offer to take a picture
		if( Platform.OS != 'web' ) {
			await Dialogue( 'Maak foto', 'Wil je een foto maken of een bestaande foto selecteren?', [ {
				text: 'Maak foto',
				onPress: f => this.updateState( { imgSource: 'camera' } )
			}, {
				text: 'Gebruik bestaande foto',
				onPress: f => this.updateState( { imgSource: 'gallery' } )
			} ] )
		}

		// Based on image source open dialog
		const { imgSource } = this.state
		let image
		if( imgSource == 'camera' ) {
			// Check current permissions
			const cameraPermission = await confirmOrAskCameraPermissions()
			if( !cameraPermission ) return Dialogue( `Je hebt niet de juiste camera permissie gegeven, we kunnen hierdoor geen foto maken.` )
			image = await ImgPick.launchCameraAsync( )
		}
		if( imgSource == 'gallery' ) image = await ImgPick.launchImageLibraryAsync( )

		// Send the image to the callback
		const { onSelected } = this.props
		if( image && !image.cancelled ) {
			if( onSelected ) onSelected( image )
			await this.updateState( { image: image } )
		}

	}

	render( ) {

		const { image: chosenImage } = this.state
		const { style, theme, size, image } = this.props

		return <TouchableOpacity onPress={ this.pickImage } style={ { alignItems: 'center', justifyContent: 'center', ...style } }>
			{ ( image || chosenImage ) ? <Avatar.Image size={ size || 100 } source={ chosenImage || image } /> : <Avatar.Icon size={ size || 100 } icon='camera' /> }
		</TouchableOpacity>

	}



}

export default connect( store => ( {
	theme: store.settings.theme
} ) )( ShowOrPickImage )